import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters('learning', ['courseContentsWithProgress'])
  }
})
export default class GtrCourseContents extends Vue {
  courseContentsWithProgress!: any

  get totalChapters () {
    return this.courseContentsWithProgress.length
  }

  get totalLessions () {
    let total = 0
    this.courseContentsWithProgress.forEach((chapter: any) => {
      if (chapter.contents.length) {
        total += chapter.contents.filter(content => content.content_type === 'lesson').length
      }
    })
    return total
  }

  get totalAssessments () {
    let total = 0
    this.courseContentsWithProgress.forEach((chapter: any) => {
      if (chapter.contents.length) {
        total += chapter.contents.filter(content => content.content_type === 'assessment').length
      }
    })
    return total
  }
}
